export type FlavorType =
  | "primary"
  | "secondary"
  | "success"
  | "danger"
  | "warning"
  | "info"
  | "light"
  | "dark";

export class Flavor {
  private flavor: FlavorType;
  public main: string;
  public hover: string;

  static flavorToTailwindClass = {
    primary: "bg-blue-500",
    secondary: "bg-gray-500",
    danger: "bg-red-500",
    success: "bg-green-500",
    warning: "bg-yellow-500",
    info: "bg-teal-500",
    light: "bg-gray-100",
    dark: "bg-gray-800",
  };

  static flavorHoverToTailwindClass = {
    primary: "hover:bg-blue-700",
    secondary: "hover:bg-gray-700",
    danger: "hover:bg-red-700",
    success: "hover:bg-green-700",
    warning: "hover:bg-yellow-700",
    info: "hover:bg-teal-700",
    light: "hover:bg-gray-200",
    dark: "hover:bg-gray-900",
  };

  constructor(flavor: FlavorType) {
    this.flavor = flavor;
    this.main = Flavor.flavorToTailwindClass[flavor];
    this.hover = Flavor.flavorHoverToTailwindClass[flavor];
  }
}

export const Primary = new Flavor("primary");
export const Secondary = new Flavor("secondary");
export const Success = new Flavor("success");
export const Danger = new Flavor("danger");
export const Warning = new Flavor("warning");
export const Info = new Flavor("info");
export const Light = new Flavor("light");
export const Dark = new Flavor("dark");
